<template>
  <fieldset class="checkbox-group">
    <legend class="checkbox-group__legend">{{ label }}</legend>
    <AntFormItem>
      <AntCheckboxGroup
        v-bind="$attrs"
        v-on="checkboxGroupListeners"
        :options="options"
        v-decorator="[name, {
          initialValue,
          preserve
        }]"
      />
    </AntFormItem>
  </fieldset>
</template>

<script>
import {
  Form as AntForm,
  Checkbox as AntCheckbox,
} from 'ant-design-vue';

import { isArrayOfShapes } from '@/common/prop-validators';

export default {
  name: 'CheckboxGroup',
  components: {
    AntFormItem: AntForm.Item,
    AntCheckboxGroup: AntCheckbox.Group,
  },
  props: {
    name: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      validator: isArrayOfShapes({
        value: [String, Number],
        label: String,
      }),
      required: true,
    },
    initialValue: {
      type: Array,
      default: () => [],
    },
    preserve: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    checkboxGroupListeners() {
      const customListeners = { change: e => this.$emit('change', e.target) };
      return { ...this.$listeners, ...customListeners };
    },
  },
};
</script>

<style lang="scss">
  .checkbox-group {
    &__legend {
      border: none !important;
      color: $primary !important;
      font-size: 14px !important;
      font-weight: 600;
      margin: 0;
    }

    .ant-checkbox-group {
      display: flex;
      flex-flow: row wrap;
      justify-content: space-between;
    }

    .ant-row.ant-form-item {
      margin: 0;
    }

    .ant-checkbox-wrapper {
      color: $primary !important;
      display: flex !important;
      font-size: 14px;
      letter-spacing: .2px;
      line-height: 1.43;
      margin-bottom: 5px;
    }

    .ant-checkbox-group-item {
      margin: 0 0 24px;
      flex: 0 0 calc(50% - 10px);

      @include md-up {
        flex: 0 0 calc(33% - 10px);
      }
    }

    input[type='checkbox'] {
      border-radius: 9px;
    }

    .ant-checkbox-inner {
      border-radius: 9px;
      border: 1.5px solid $red !important;
      height: 30px;
      width: 30px;

      &::after {
        left: 30%;
      }
    }

    .ant-checkbox {
      + span {
        color: $primary;
        font-size: 14px;
        font-weight: 500;
        letter-spacing: .32px;
        line-height: 30px;
        margin-left: 18px;
        padding: 0;
      }

      &.ant-checkbox-checked {
        height: 30px;
        width: 30px;

        .ant-checkbox-inner {
          background-color: $red;

          &::after {
            transform: rotate(45deg) scale(1.7) translate(-50%, -40%);
          }
        }
      }
    }
  }
</style>
